<template>
  <div>
    <h2>
      Балансы
    </h2>
    <vue-good-table
        :columns="columns"
        :rows="transactions"
        :search-options="{
        enabled: true,
        externalQuery: searchTerm }"
        :pagination-options="{
        enabled: true,
        perPage:pageLength
      }"
    >
      <template
          slot="table-row"
          slot-scope="props"
      >

        <!-- Column: Name -->
        <span v-if="props.column.field === 'user_id'">
          <b-badge>
            {{ getModelName('students', props.row.user_id, 'name') }}
          </b-badge>
        </span>

        <span v-else-if="props.column.field === 'created_at'">
          {{ getFormattedDate(props.row.created_at) }}
        </span>

        <!-- Column: Common -->
        <span v-else>
          {{ props.formattedRow[props.column.field] }}
        </span>
      </template>

      <!-- pagination -->
      <template
          slot="pagination-bottom"
          slot-scope="props"
      >
        <div class="d-flex justify-content-between flex-wrap">
          <div class="d-flex align-items-center mb-0 mt-1">
            <span class="text-nowrap">
              Showing 1 to
            </span>
            <b-form-select
                v-model="pageLength"
                :options="['3','5','10']"
                class="mx-1"
                @input="(value)=>props.perPageChanged({currentPerPage:value})"
            />
            <span class="text-nowrap "> of {{ props.total }} entries </span>
          </div>
          <div>
            <b-pagination
                :value="1"
                :total-rows="props.total"
                :per-page="pageLength"
                first-number
                last-number
                align="right"
                prev-class="prev-item"
                next-class="next-item"
                class="mt-1 mb-0"
                @input="(value)=>props.pageChanged({currentPage:value})"
            >
              <template #prev-text>
                <feather-icon
                    icon="ChevronLeftIcon"
                    size="18"
                />
              </template>
              <template #next-text>
                <feather-icon
                    icon="ChevronRightIcon"
                    size="18"
                />
              </template>
            </b-pagination>
          </div>
        </div>
      </template>
    </vue-good-table>
  </div>
</template>

<script>

import {
  BPagination,
  BFormSelect
} from 'bootstrap-vue'
import {VueGoodTable} from 'vue-good-table'
import {createNamespacedHelpers} from 'vuex';
import formattedDate from '@/mixins/formattedDate'

const {mapState, mapActions} = createNamespacedHelpers('crm')

export default {
  components: {
    VueGoodTable,
    BPagination,
    BFormSelect,
  },
  mixins: [formattedDate],
  data() {
    return {
      pageLength: 3,
      dir: false,
      columns: [
        {
          label: 'Имя',
          field: 'user_id',
        },
        {
          label: 'Баланс',
          field: 'amount',
        },
        {
          label: 'Дата создания транзакции',
          field: 'created_at',
        },
      ],
      rows: [],
      searchTerm: '',
      balances: [],
    }
  },
  computed: {
    ...mapState({
      transactions: state => state.allTransactions,
      students: state => state.students
    })
  },
  methods: {
    ...mapActions(['getAllTransactions', 'getUsers'])
  },
  created() {
    this.getUsers();
    this.getAllTransactions()
  }
}
</script>

<style scoped>

</style>
